import React from "react";
import { Button, Checkbox, Menu, MenuButton, MenuDivider, MenuItem, MenuList, Text, Box } from "@chakra-ui/react";
function splitMulti(value) {
    return value
        .split(",")
        .map((s) => s.trim())
        .filter(Boolean);
}
function joinMulti(values) {
    return Array.from(new Set(values)).join(",");
}
export class MultiSelectDropdown extends React.PureComponent {
    constructor() {
        super(...arguments);
        this.toggle = (opt) => {
            const selected = new Set(splitMulti(this.props.valueCsv));
            if (selected.has(opt))
                selected.delete(opt);
            else
                selected.add(opt);
            this.props.onChangeCsv(joinMulti(Array.from(selected)));
        };
        this.clear = () => {
            this.props.onChangeCsv("");
        };
        this.selectAll = () => {
            this.props.onChangeCsv(joinMulti(this.props.options));
        };
    }
    renderButtonText() {
        var _a;
        const selected = splitMulti(this.props.valueCsv);
        if (!selected.length)
            return (_a = this.props.placeholder) !== null && _a !== void 0 ? _a : "All";
        if (selected.length === 1)
            return selected[0];
        return `${selected.length} selected`;
    }
    render() {
        const { label, options, valueCsv } = this.props;
        const selected = new Set(splitMulti(valueCsv));
        return (React.createElement(Menu, { closeOnSelect: false },
            React.createElement(MenuButton, { as: Button, variant: "outline", w: "100%", justifyContent: "space-between" },
                React.createElement(Box, { textAlign: "left" },
                    React.createElement(Text, { fontSize: "xs", color: "gray.600", lineHeight: "1" }, label),
                    React.createElement(Text, { fontSize: "sm", fontWeight: "semibold" }, this.renderButtonText()))),
            React.createElement(MenuList, { minW: "260px", maxH: "320px", overflowY: "auto" },
                React.createElement(MenuItem, { onClick: this.selectAll },
                    React.createElement(Text, { fontSize: "sm" }, "Select all")),
                React.createElement(MenuItem, { onClick: this.clear },
                    React.createElement(Text, { fontSize: "sm" }, "Clear")),
                React.createElement(MenuDivider, null),
                options.map((opt) => (React.createElement(MenuItem, { key: opt, onClick: () => this.toggle(opt) },
                    React.createElement(Checkbox, { isChecked: selected.has(opt), pointerEvents: "none" }, opt)))))));
    }
}
